export default "__VITE_ASSET__B3a4ytNF__"